/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';

export interface SondageForm {
  id?: number;
  name: string;
  desc: string;
  config: Config;
  experation: Date;
  ispublic: boolean;
}

export interface Config {
  type: string,
  questions: any[];

}
export interface FormResp {
  id: number;
  formId: string;
  response: string;
  time: Date;
}

export abstract class SondageFormData {
  abstract get gridDataSource(): DataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<SondageForm[]>;
  abstract getAll(): Observable<SondageForm[]>;
  abstract get(id: number): Observable<SondageForm>;
  abstract getPublic(id: number): Observable<SondageForm>;
  abstract update(ondageForm: SondageForm): Observable<SondageForm>;
  abstract create(sondageForm: SondageForm): Observable<SondageForm>;
  abstract delete(id: number): Observable<boolean>;
  abstract saveResp(formResp: FormResp): Observable<FormResp>;
  abstract getAllResp(id: number): Observable<FormResp[]>;


}
